import React, {ReactElement, useContext} from 'react';

import './FundingOptionsLogo.scss';
import DeviceContext, {Device} from '../../../RootProvider/DeviceContext';

import {ReactComponent as FundingOptionsLogoOnly} from '../../../images/fundingOptionsLogoYellow.svg';
import {ReactComponent as FundingOptionsLogoWithText} from '../../../images/fundingOptionsLogoWithTextYellow.svg';

interface Props {
  className?: string;
}

function FundingOptionsLogo({className}: Props): ReactElement {
  const device = useContext(DeviceContext);

  return device === Device.MOBILE ? (
    <FundingOptionsLogoOnly className={className || ''} />
  ) : (
    <FundingOptionsLogoWithText className={className || ''} />
  );
}

export default FundingOptionsLogo;
